import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../../components/Hero";
import MvpSteps from "../../components/MvpSteps";
import WhatIDo from "../../components/WhatIDo";
import About from "../../components/About";
import CaseStudies from "../CaseStudies";
import Blog from "../Blog";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const timer = setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [hash]);

  return (
    <>
      <Hero />
      <MvpSteps />
      <About />
      {/* <WhatIDo /> */}
      <CaseStudies />
      <Blog />
    </>
  );
};

export default Home;
